var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnterpriseBlack({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3115 2.32617C12.3733 4.04768 14.9884 5.1278 17.8516 5.26172C17.9188 5.76957 17.9551 6.28779 17.9551 6.81445C17.955 11.8518 14.7746 16.145 10.3115 17.7998C5.84848 16.1449 2.66803 11.8517 2.66797 6.81445C2.66797 6.28784 2.7033 5.76952 2.77051 5.26172C5.6341 5.12804 8.24953 4.04786 10.3115 2.32617ZM14.4385 6.75879C13.8457 6.1662 12.8847 6.16606 12.292 6.75879L9.29297 9.75684L8.33105 8.79492C7.73827 8.20213 6.77737 8.20215 6.18457 8.79492C5.59177 9.38772 5.59177 10.3486 6.18457 10.9414L8.2207 12.9775C8.81352 13.5701 9.77448 13.5702 10.3672 12.9775L14.4385 8.90527C15.0313 8.31248 15.0313 7.35159 14.4385 6.75879Z",
    fill: "#23242A",
    stroke: "#23242A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnterpriseBlack);
export default __webpack_public_path__ + "static/media/enterprise-black.d41e9bedaa8323544a8f5aaea0a4a924.svg";
export { ForwardRef as ReactComponent };